import { fetchUserProfile } from "@services/user";
import { useQuery } from "@tanstack/react-query";

export const useUserProfile = () => {
  return useQuery({
    queryKey: ["userProfile"],
    queryFn: fetchUserProfile,
    retry: false, // No reintentar si falla (para no crear bucles de redirección)
    refetchOnWindowFocus: false,
    refetchOnMount: true // Forzar que se ejecute al montar el componente
  });
};
